export function dropLeadingZeroDays<T>(
  series: T[],
  isZero: (item: T) => boolean,
): T[] {
  const firstNonZero = series.findIndex((item) => !isZero(item));
  return firstNonZero <= 0 ? series : series.slice(firstNonZero);
}
